import {Dialog, styled} from '@mui/material';

const GenericDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    backgroundImage: 'none',
  },
}));

export default GenericDialog;
